'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UserProfile from 'MeetingsBase/models/UserProfile';
import { getLongDisplayName } from 'MeetingsLib/utils/utils';
import Big from 'UIComponents/elements/Big';
import H4 from 'UIComponents/elements/headings/H4';
import UILink from 'UIComponents/link/UILink';
export default createReactClass({
  displayName: "ZeroState",
  propTypes: {
    profile: PropTypes.instanceOf(UserProfile).isRequired,
    linkUse: PropTypes.string,
    TimePickerMarker: PropTypes.func.isRequired
  },
  renderZeroStateText: function renderZeroStateText() {
    var _this$props = this.props,
        profile = _this$props.profile,
        linkUse = _this$props.linkUse;
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "prebook.timeOptions.zeroState_jsx",
      options: {
        href: "mailto:" + profile.email,
        external: true,
        use: linkUse,
        email: profile.email
      },
      elements: {
        Link: UILink
      }
    });
  },
  render: function render() {
    var _this$props2 = this.props,
        profile = _this$props2.profile,
        TimePickerMarker = _this$props2.TimePickerMarker;
    return /*#__PURE__*/_jsxs("div", {
      className: "text-center",
      children: [/*#__PURE__*/_jsx(H4, {
        role: "alert",
        tabIndex: "1",
        "aria-level": 2,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "prebook.timeOptions.sorry",
          options: {
            fullName: getLongDisplayName(profile)
          }
        })
      }), /*#__PURE__*/_jsx(Big, {
        children: this.renderZeroStateText()
      }), /*#__PURE__*/_jsx(TimePickerMarker, {})]
    });
  }
});